export default __webpack_public_path__ + "static/Austin-4f88cbae9365a64d7a569982f5ef0319.webp";